import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { IMeetingBlueprintTriggerJobDetails, IMeetingBlueprintTriggerJobResults } from '../../../api/jobs.dao';

const meetingBlueprintTriggerJobProperties:
    IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IMeetingBlueprintTriggerJobDetails, IMeetingBlueprintTriggerJobResults>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: () => {
        return <span className='alert-message'>Meeting setup is complete</span>;
    },
    failedComponent: () => {
        return <span className='alert-message'>Meeting setup has failed</span>;
    }
};

export { meetingBlueprintTriggerJobProperties };
